<h2 [hidden]="loading" class="tt-page-heading" [ngStyle]="style['heading']">
    <span>{{ _model }}</span>
    <ng-content></ng-content>
</h2>
<div [hidden]="!loading" class="tt-skeleton tt-skeleton--page-heading" [ngStyle]="style['skeleton']"></div>
